<template>
  <c-tab
    type="pagetop"
    :tabItems.sync="tabItems"
    :dense="true"
    :inlineLabel="true"
    v-model="tab"
    align="left"
  >
    <template v-slot:default="tab">
      <component
        :is="tab.component"
        :patrolInfo.sync="patrolInfo"
      />
    </template>
  </c-tab>
</template>

<script>
export default {
  name: 'patrolGraph',
  props: {
    patrolInfo: {
      type: Object,
      default(){
        return {
          patrolFstCd: null,
          typeDisabled: false,
        }
      },
    },
  },
  data() {
    return {
      tab: 'status',
      tabItems: [
        // 결과별 지적사항 현황
        { name: 'status', icon: 'grading', label: '부서별 지적사항 현황', component: () => import(`${'./patrolStatus.vue'}`) },
        // 월별 지적사항 건 수
        { name: 'month', icon: 'bar_chart', label: '월별 지적사항 건 수', component: () => import(`${'./patrolMonthGraph.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
    },
  }
};
</script>
